"use client";

import { FC, HTMLAttributes, useContext } from "react";
import clsx from "clsx";

import { leadershipBlogsSubCategoryContext } from "@/stores/LeadershipBlogsSubCategory.context";
import ListWithHeading from "../common/ListWithHeading";

// ----------------------------------------------------------------------------

export type IBlogsSubcategoryData = {
  heading?: string;
  items?: (string | undefined)[];
};

type IExploreCategoriesSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  blogsByFunctions?: IBlogsSubcategoryData;
  blogsByProcesses?: IBlogsSubcategoryData;
  blogsByRoles?: IBlogsSubcategoryData;
};

// Scroll to #latest-blogs section
const scrollToLatestBlogs = () => {
  const element = document.getElementById("latest-blogs");
  if (element) {
    const yOffset = -60; // Offset by 60px
    const elementDistance =
      element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: elementDistance, behavior: "smooth" });
  }
};

const ExploreCategoriesSection: FC<IExploreCategoriesSectionProps> = (
  props,
) => {
  const {
    heading,
    blogsByFunctions,
    blogsByProcesses,
    blogsByRoles,
    className,
    ...other
  } = props;

  const {
    activeBlogsByFunctions,
    activeBlogsByRoles,
    activeBlogsByProcesses,
    setActiveBlogsByFunctions,
    setActiveBlogsByRoles,
    setActiveBlogsByProcesses,
  } = useContext(leadershipBlogsSubCategoryContext);

  if (!heading && !blogsByFunctions && !blogsByProcesses && !blogsByRoles) {
    return;
  }

  return (
    <section
      className={clsx("py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="flex justify-center bg-primary-50 py-5 lg:py-8 xl:py-[50px]">
        <div className="container w-full">
          {heading && (
            <h2 className="mb-5 text-h5 font-medium text-black-900 md:mb-7 lg:mb-12 lg:text-h3 xl:text-h2">
              {heading}
            </h2>
          )}
          <div className="flex w-full flex-col justify-between gap-2 md:flex-row md:gap-7">
            {/* Blogs By Functions Filters */}
            {/* Multiselect: Please remove and uncomment below lines */}
            <ListWithHeading
              heading={blogsByFunctions?.heading}
              items={blogsByFunctions?.items}
              activeValue={activeBlogsByFunctions}
              setActiveValue={setActiveBlogsByFunctions}
              scrollToSection={scrollToLatestBlogs}
            />
            {/* {blogsByFunctions?.items && blogsByFunctions.items.length > 0 && (
              <ListWithHeading
                heading={blogsByFunctions?.heading}
                items={blogsByFunctions?.items}
                activeValue={activeBlogsByFunctions}
                setActiveValue={setActiveBlogsByFunctions}
                scrollToSection={scrollToLatestBlogs}
              />
            )} */}

            {/* Blogs By Roles Filters */}
            {/* Multiselect: Please remove and uncomment below lines */}
            <ListWithHeading
              heading={blogsByRoles?.heading}
              items={blogsByRoles?.items}
              activeValue={activeBlogsByRoles}
              setActiveValue={setActiveBlogsByRoles}
              scrollToSection={scrollToLatestBlogs}
            />
            {/* {blogsByRoles?.items && blogsByRoles.items.length > 0 && (
              <ListWithHeading
                heading={blogsByRoles?.heading}
                items={blogsByRoles?.items}
                activeValue={activeBlogsByRoles}
                setActiveValue={setActiveBlogsByRoles}
                scrollToSection={scrollToLatestBlogs}
              />
            )} */}

            {/* Blogs By Process Filters */}
            {/* Multiselect: Please remove and uncomment below lines */}
            <ListWithHeading
              heading={blogsByProcesses?.heading}
              items={blogsByProcesses?.items}
              activeValue={activeBlogsByProcesses}
              setActiveValue={setActiveBlogsByProcesses}
              scrollToSection={scrollToLatestBlogs}
            />
            {/* {blogsByProcesses?.items && blogsByProcesses.items.length > 0 && (
              <ListWithHeading
                heading={blogsByProcesses?.heading}
                items={blogsByProcesses?.items}
                activeValue={activeBlogsByProcesses}
                setActiveValue={setActiveBlogsByProcesses}
                scrollToSection={scrollToLatestBlogs}
              />
            )} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreCategoriesSection;
